/**
 * Helpers pour le compteur d'engagement (3 mois minimum, cf double garantie 2026-05-04).
 */

const MIN_COMMITMENT_MONTHS = 3;

/**
 * Returns the date until which the client is contractually engaged.
 * Pure date math — no I/O. Works with strings or Date.
 */
export function engagementUntil(startedAt: string | Date | null): Date | null {
  if (!startedAt) return null;
  const start = startedAt instanceof Date ? startedAt : new Date(startedAt);
  if (Number.isNaN(start.getTime())) return null;
  const end = new Date(start);
  end.setMonth(end.getMonth() + MIN_COMMITMENT_MONTHS);
  return end;
}

/**
 * Days remaining until the end of the 3-month commitment.
 * Negative = engagement already cleared (free to cancel any time).
 * Null = invalid started_at.
 */
export function engagementDaysRemaining(
  startedAt: string | Date | null,
  now: Date = new Date()
): number | null {
  const end = engagementUntil(startedAt);
  if (!end) return null;
  const diffMs = end.getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export const ENGAGEMENT_MIN_MONTHS = MIN_COMMITMENT_MONTHS;
